import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import AnimateHeight from 'react-animate-height';
import {salesChannelRegister} from "../../services/salesChannelRegister";

class FaqPrivate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accordion: [],
            lang: "en",
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateLang();
    }

    _updateLang() {
        this.setState({lang: this.props.lang, name: this.props.name}, () => {
            this._updateAccordion();
        });
    }

    _updateAccordion() {

        let accordion = [{
            title: langRegister.get("faq-private", "item_1", this.state.lang),
            text: langRegister.get("faq-private", "item_2", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_3", this.state.lang),
            text: langRegister.get("faq-private", "item_4", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_5", this.state.lang),
            text: langRegister.get("faq-private", "item_6", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_7", this.state.lang),
            text: langRegister.get("faq-private", "item_8", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_9", this.state.lang),
            text: langRegister.get("faq-private", "item_10", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_11", this.state.lang),
            text: langRegister.get("faq-private", "item_12", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_13", this.state.lang),
            text: langRegister.get("faq-private", "item_14", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_15", this.state.lang),
            text: langRegister.get("faq-private", "item_16", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_17", this.state.lang),
            text: langRegister.get("faq-private", "item_18", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_19", this.state.lang),
            text: langRegister.get("faq-private", "item_20", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_21", this.state.lang),
            text: langRegister.get("faq-private", "item_22", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_23", this.state.lang),
            text: langRegister.get("faq-private", "item_24", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_25", this.state.lang),
            text: langRegister.get("faq-private", "item_26", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_27", this.state.lang),
            text: langRegister.get("faq-private", "item_28", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_29", this.state.lang),
            text: langRegister.get("faq-private", "item_30", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_31", this.state.lang),
            text: langRegister.get("faq-private", "item_32", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_33", this.state.lang),
            text: langRegister.get("faq-private", "item_34", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_35", this.state.lang),
            text: langRegister.get("faq-private", "item_36", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_37", this.state.lang),
            text: langRegister.get("faq-private", "item_38", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_39", this.state.lang),
            text: langRegister.get("faq-private", "item_40", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_41", this.state.lang),
            text: langRegister.get("faq-private", "item_42", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_43", this.state.lang),
            text: langRegister.get("faq-private", "item_44", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_45", this.state.lang),
            text: langRegister.get("faq-private", "item_46", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_47", this.state.lang),
            text: langRegister.get("faq-private", "item_48", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_49", this.state.lang),
            text: langRegister.get("faq-private", "item_50", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq-private", "item_51", this.state.lang),
            text: langRegister.get("faq-private", "item_52", this.state.lang),
            height: 0
        },
            {
                title: langRegister.get("faq-private", "item_53", this.state.lang),
                text: langRegister.get("faq-private", "item_54", this.state.lang),
                height: 0
            }, {
                title: langRegister.get("faq-private", "item_55", this.state.lang),
                text: langRegister.get("faq-private", "item_56", this.state.lang),
                height: 0
            }];

        for(let i = 0; i < accordion.length; i++){
            accordion[i].title = this._renderFaqLine(accordion[i].title);
            accordion[i].text = this._renderFaqLine(accordion[i].text);
        }

        this.setState({accordion: accordion});
    }

    _renderFaqLine(line){
        line = line.replace(/##name##/g, "inhouse");
        return line;
    }

    _renderText(item) {
        return langRegister.get("help", item, this.state.lang);
    }

    render() {
        return (
            <div>
                <div className={Styles.sectionEighteenContainer}>
                    {
                        this.state.accordion.map((item) => {
                            return (
                                <div className={Styles.sectionEighteenItem}>
                                    <div onClick={() => {
                                        item.height = item.height === 0 ? 'auto' : 0;
                                        this.setState({accordion: this.state.accordion})
                                    }} className={Styles.sectionEighteenItemTitle}>
                                        {item.title}
                                        {
                                            item.height === 0 &&
                                            <img className={Styles.sectionEighteenItemIconPlusIcon}
                                                 src={require("../../assets/images/AB_plus_black.png")}/>
                                        }
                                        {
                                            item.height === "auto" &&
                                            <img className={Styles.sectionEighteenItemIconMinusIcon}
                                                 src={require("../../assets/images/AB_minus_black.png")}/>
                                        }
                                    </div>
                                    <AnimateHeight
                                        duration={100}
                                        height={item.height} // see props documentation bellow
                                    >
                                        <div className={Styles.sectionEighteenItemText}>{item.text}</div>
                                    </AnimateHeight>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default FaqPrivate;


// WEBPACK FOOTER //
// ./src/components/faq-private/component.js